import React from 'react';
import {
    getPrecisePriceWithCurrency,
    getPriceWithDisplayCurrencyByPrecision,
    getFreelancerExchangeRate,
} from 'arbitrip-common/general/utils/Currencies';
import { useTranslation } from 'react-i18next';
import { getPriceValue, getBookingPricingBreakdown, getAggregatedPricingBreakdown } from '../utils';
import { isAccountBooking } from '@/utils/AccountBankTransfer';

const PaymentSummary = ({ profile, booking, bookings, isMultiMode, chargeCurrency: selectedChargeCurrency }) => {
	const { t } = useTranslation();

	// An Account request is recorded in `payment.currency`; there is no charge currency to convert into.
	const chargeCurrency = isAccountBooking(booking) ? null : selectedChargeCurrency;

	const isAggregate = isMultiMode && Array.isArray(bookings) && bookings.length > 1;

	if (isAggregate) {
		const { currencies, totalsByCurrency, unpriceableBookings } = getAggregatedPricingBreakdown(bookings);

		return (
			<div className="payment-method__summary">
				<div className="payment-method__title">{t('TotalToPay')}</div>
				{unpriceableBookings.length > 0 && (
					<div className="payment-method__unpriceable-warning">
						{t('Bookings.SettlePayment.UnpriceableBookingsExcluded', { count: unpriceableBookings.length })}
					</div>
				)}
				<div className="payment-method__sum">
					{currencies
						.map((currency) => {
							const { total_to_pay } = totalsByCurrency[currency];
							const additional_currency = chargeCurrency && chargeCurrency !== currency;

							return additional_currency
								? getPriceWithDisplayCurrencyByPrecision(
										total_to_pay,
										getFreelancerExchangeRate(profile, currency, chargeCurrency),
										chargeCurrency,
										2,
									)
								: getPrecisePriceWithCurrency(total_to_pay, currency);
						})
						.join(' + ')}
				</div>
				{currencies.map((currency) => {
					const { total_commission } = totalsByCurrency[currency];

					return (
						!!total_commission && (
							<div className="payment-method__commission" key={currency}>
								{t('Commission')} {getPriceValue(total_commission, currency, chargeCurrency, profile)}
							</div>
						)
					);
				})}
			</div>
		);
	}

	const { currency, total_commission, total_to_pay, total_to_pay_currency, isPriceable } = getBookingPricingBreakdown(booking);

	const additional_currency = chargeCurrency && chargeCurrency !== total_to_pay_currency;

	return (
		<div className="payment-method__summary">
			<div className="payment-method__title">{t('TotalToPay')}</div>
			{!isPriceable && (
				<div className="payment-method__unpriceable-warning">
					{t('Bookings.SettlePayment.UnpriceableBookingsExcluded', { count: 1 })}
				</div>
			)}
			<div className="payment-method__sum">
				{!isPriceable ? (
					'—'
				) : additional_currency ? (
					<React.Fragment>
						{getPriceWithDisplayCurrencyByPrecision(
							total_to_pay,
                            getFreelancerExchangeRate(profile, total_to_pay_currency, chargeCurrency),
							chargeCurrency,
							2,
						)}
					</React.Fragment>
				) : (
					getPrecisePriceWithCurrency(total_to_pay, total_to_pay_currency)
				)}
			</div>
			{!!total_commission && <div className="payment-method__commission">
				{t('Commission')} {getPriceValue(total_commission, currency, chargeCurrency, profile)}
			</div>}
		</div>
	);
};

export default PaymentSummary;
